var map = {
	"./Alexia-300-Para tarefas domésticas.jpg": 5519,
	"./Aluguel-500,00-Ajuda nos 14 meses de aluguel atrasados.jpg": 3485,
	"./Aposentadoria garantida para o noivo-1000,00-É para aposentadoria mesmo.jpg": 2328,
	"./Aula de Culinária-350,00-Alguém tem que ensinar a noiva..jpg": 2378,
	"./Aula de dança-400,00-Para não pagar mico no casamento..jpg": 2224,
	"./Aviãozinho de Dinheito-60,00-Dinheiro aos noivos.jpg": 8204,
	"./Buque-150,00-Taxa para a noiva não jogar o buquê, vai que cola..jpg": 7911,
	"./Gatinhos-155,59-Adote e seja feliz..jpg": 2337,
	"./Jantar a dois-250,00-Ajuda o noivo a ser romantico.png": 3081,
	"./Monalisa-300,00-Compre uma self..png": 6542,
	"./Netflix [Entretenimento]-200,00-Momento de discanso ao casal..jpg": 6065,
	"./Outra caneca...-100,00-Mas essa é do noivo..jpg": 293,
	"./Relógios-150,00-.Por quê o noivo é viciado mesmo..png": 7204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5988;